<template>
  <div>
    <b-row>
      <b-col>
        <b-card v-if="!isLoading">
          <h5>{{$t('notifications')}}</h5>
            <b-table
              :fields="fields"
              :items="notifications2.results"
              show-empty
              responsive
              hover
              :empty-text="$t('empty_text')"
              @row-clicked="goToPlace($event)"
            >
              <template #head()="props">
                <span>{{ $t(props.label) }}</span>
              </template>
              <template #cell(created_date)="props">
                <span>{{ $dayjs(props.item.created_date).format("DD.MM.YYYY") }}</span>
              </template>

              <template #cell(actions)="{ item }">
                <div>
                  
                </div>
              </template>
            </b-table>



        </b-card>
        <b-card v-else>
          <Loader />
        </b-card>


        <Pagination
          class="w-100"
          :params="filter"
          :rows="notifications2.count"
          @refresh="refresh"
        />
      </b-col>


    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BTable,
  VBTooltip,
  BFormRadio,
  BFormRadioGroup,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapState } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import priceFormatMixin from "@/mixins/priceFormatMixin.js";

export default {
  components: {
    AppSearchInput,
    VueDataPicker,
    Pagination,
    vSelect,
    Loader,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BTable,
    BBadge,
    BCard,
    BFormRadio,
    BFormRadioGroup,
    BTable,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, check, loader, priceFormatMixin],
  data() {
    return {
      isLoading: false,
      filter: {
        search: null,
        requirement_type: null,
        author: null,
        storage: null,
        start_date: null,
        end_date: null,

        page_size: 10,
        page: 1,
      },
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: true,
        },
        {
          text: this.$t("reference.instrument"),
          value: false,
        },
      ],
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "text",
          key: "message",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "date",
          key: "created_date",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "actions",
        //   key: "actions",
        //   thClass: "tableHeadClass",
        //   tdClass: "text-center",
        // },
      ],
    };
  },
  computed: {
    ...mapState('app', ['notifications2']),
  },
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;
    await this.FETCH_ALL_NOTIFICATIONS2()
    // setTimeout(async () => {
    //   await this.FETCH_NOTIFICATIONS_SET_NOTIF()
    // }, 1500)
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions('app', ['FETCH_ALL_NOTIFICATIONS2', 'FETCH_NOTIFICATIONS_SET_NOTIF']),
    async refresh() {
        this.isLoading = true;
        await this.FETCH_ALL_NOTIFICATIONS2(this.filter);
        this.isLoading = false;
    },


    async goToPlace(notification){
      console.log(notification)
      if(notification.content_type == 'requirement_for_good'){
        this.$router.push(`/applications/material/view/${notification.object_id}`)
        this.refreshViewMaterial = !this.refreshViewMaterial
      }else if(notification.content_type == 'requirement_for_instrument'){
        this.$router.push(`/applications/instrument/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_brigade'){
        this.$router.push(`/applications/works/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_transport'){
        this.$router.push(`/applications/transport/view/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_good'){
        this.$router.push(`/return/view/material/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_instrument'){
        this.$router.push(`/return/view/instrument/${notification.object_id}`)
      }else if(notification.content_type == 'contract'){
        this.$router.push(`/view-agreements/${notification.object_id}`)
      }

      
      await this.$socket.send(JSON.stringify({pk: notification.id, action: "read_notification", request_id: Date.now()}))
      setTimeout(async () => {
        await this.FETCH_ALL_NOTIFICATIONS2()
      }, 500)
    }


  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}


[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}
#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
